import React from 'react';

type OwnProps = {
  className?: string;
};

const NotificationBell = ({ className }: OwnProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="16"
    viewBox="0 0 13 15"
    className={className}
  >
    <g>
      <path d="M10.28 6.067c.78 1.733 2.04.74 2.662 2.54.454 1.311-1.776 3.996-5.308 5.35-3.532 1.352-6.879.803-7.333-.51-.622-1.798.95-1.89.49-3.745C-.305 5.295-.522 3.446 1.836 1.449c.84-.713.136-1.173.957-1.488.822-.314.563.515 1.641.492C7.463.388 8.425 1.95 10.28 6.067m-3.034 6.78c3.152-1.207 4.718-3.462 4.593-3.822-.21-.608-2.22-1.121-5.823.26-3.603 1.382-4.809 3.2-4.62 3.744.11.316 2.699 1.026 5.85-.182m-1.008-2.93c.215-.083.424-.158.628-.227l.012.03c.301.87-.46 1.962-1.702 2.437-.975.373-1.953.254-2.475-.236.742-.65 1.888-1.373 3.537-2.005" />
    </g>
  </svg>
);

export default NotificationBell;
